export default __webpack_public_path__ + "images/8W.d33549f.png";